import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column, Text } from '@dossierhq/design';
import { MapContainer } from '@dossierhq/leaflet';
import { StatusTag } from '../StatusTag/StatusTag.js';
export function AdminEntityMapMarker({ entity, location, onClick }) {
    return (_jsx(MapContainer.Marker, { location: location, tooltip: _jsxs(Column, { children: [_jsx(Text, { textStyle: "subtitle1", children: entity.info.name }), _jsxs(Text, { textStyle: "body1", children: [entity.info.type, " ", _jsx(StatusTag, { status: entity.info.status })] })] }), onClick: onClick }));
}
//# sourceMappingURL=AdminEntityMapMarker.js.map